import { createSlice } from "@reduxjs/toolkit";

/**
 * /sign-in/ 画面に関連する state
 * signIn.screen1 .. QRコード読み取り直後の画面でのみ利用するデータ
 */
const signIn = createSlice({
  name: "SignIn",
  initialState: {},
  reducers: {
    inputForm(state, action) {
      state.screenSignIn = state.screenSignIn || {};
      state.screenSignIn[action.payload.formId] = action.payload.value;
    },
    sendError(state, action) {
      state.screenSignIn = state.screenSignIn || {};
      state.screenSignIn.error = true;
      state.screenSignIn.isFetching = false;
      state.screenSignIn["password"] = "";
    },
    requestSignIn(state, action) {
      state.screenSignIn = state.screenSignIn || {};
      state.screenSignIn.error = false;
      state.screenSignIn.isFetching = true;
    },
    /**
     * SignIn API の実行に成功した
     */
    succeededSignInApi(state) {
      state.screenSignIn = state.screenSignIn || {};
      state.screenSignIn.succeededSignInApi = true;
    },
  },
});

const { reducer } = signIn;
export const { actions } = signIn;
export default reducer;
